module.exports = __webpack_public_path__ + "static/vegly-logo-6a773739da883843f1b284da0fec8bef.svg";